import React, { useState } from 'react';
import { BsFillPlayFill, BsPauseFill } from 'react-icons/bs'
import { meal } from '../../constants';



const Intro = () => {
  const vidRef = React.useRef();
  const [playVideo, setPlayVideo] = useState(false);

  const handleVideo = () => {
    setPlayVideo( (prevValue) => !prevValue );
    if(playVideo) {
      vidRef.current.pause();
    } else {
      vidRef.current.play();
    }
  }

  return (
      <div className='app__video' >
        <video src={meal} itemType='video/mp4' ref={vidRef} loop controls={false} muted />
        <div className='app__video-overlay flex__center' >
          <div className='app__video-overlay_circle flex__center' onClick={handleVideo} >
            {
              playVideo ? <BsPauseFill className='playback__buttons' /> : <BsFillPlayFill className='playback__buttons' />
            }
          </div>
        </div>
      </div>
  )
} 

export default Intro;
